import React, { useState, useEffect, useCallback } from 'react'
import DatePicker from 'react-datepicker'
import { GET, httpOk } from 'helpers/api'
import { formatDate } from 'helpers/helpers'

const QUICK = [
	{ id: 'today', label: 'Bugun' },
	{ id: 'week', label: '7 kun' },
	{ id: 'month', label: '30 kun' },
]

function getRange(id) {
	const now = new Date()
	const fmt = d => formatDate(d, 'yyyy-MM-dd')
	if (id === 'today') return { start: fmt(now), end: fmt(now) }
	if (id === 'week') { const d = new Date(now); d.setDate(d.getDate() - 6); return { start: fmt(d), end: fmt(now) } }
	if (id === 'month') { const d = new Date(now); d.setDate(d.getDate() - 29); return { start: fmt(d), end: fmt(now) } }
	return { start: fmt(now), end: fmt(now) }
}

/* Kraskachilar (6/7) kg bilan o'lchanadi, qolgan sexlar metr/kv.m bilan.
   Ilgari dashboard HAMMA bo'limni kg deb ko'rsatardi — aksessuar 305 metr
   ish qilsa ham «0.0 kg» chiqardi. */
const PAINT_TYPES = [6, 7]
const isPaint = id => PAINT_TYPES.includes(Number(id))

const trim = (v, d = 1) => {
	const n = Number(v || 0)
	return Number.isFinite(n) ? String(Number(n.toFixed(d))) : '0'
}

/** Bo'limning asosiy raqami: kraskachida kg, boshqasida metr/kv.m */
function mainAmount(dept) {
	return isPaint(dept.product_type_id)
		? trim(dept.total_paint_kg, 1) + ' kg'
		: trim(dept.total_metr, 1) + ' ' + (dept.unit || 'metr')
}

export default function DailyDashboard() {
	const now = new Date()
	const [activeFilter, setActiveFilter] = useState('week')
	const [startDate, setStartDate] = useState(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6))
	const [endDate, setEndDate] = useState(now)
	const [departments, setDepartments] = useState([])
	const [loading, setLoading] = useState(false)

	const load = useCallback(async (sd, ed) => {
		setLoading(true)
		const res = await GET('/daily-work/dashboard', {
			start_date: formatDate(sd, 'yyyy-MM-dd'),
			end_date: formatDate(ed, 'yyyy-MM-dd'),
		}, { loader: false })
		if (httpOk(res)) setDepartments(res.data)
		setLoading(false)
	}, [])

	useEffect(() => {
		load(startDate, endDate)
	}, [load]) // eslint-disable-line react-hooks/exhaustive-deps

	function applyQuick(id) {
		setActiveFilter(id)
		const { start, end } = getRange(id)
		const s = new Date(start), e = new Date(end)
		setStartDate(s)
		setEndDate(e)
		load(s, e)
	}

	function applyRefresh() {
		setActiveFilter(null)
		load(startDate, endDate)
	}

	const deptColors = ['#4f46e5', '#0891b2', '#059669', '#d97706', '#dc2626', '#7c3aed']

	return (
		<div className="an-page">
			<div className="page-header d-flex justify-content-between align-items-center mb-3">
				<h4 className="mb-0">DASHBOARD kunlik ish</h4>
			</div>

			{/* Filter bar */}
			<div className="card mb-3">
				<div className="card-body py-2 px-3">
					<div className="d-flex align-items-center gap-2 flex-wrap">
						{QUICK.map(q => (
							<button key={q.id}
								className={`btn btn-sm ${activeFilter === q.id ? 'btn-primary' : 'btn-outline-secondary'}`}
								onClick={() => applyQuick(q.id)}>
								{q.label}
							</button>
						))}
						<div style={{ width: 1, height: 28, background: '#dee2e6', margin: '0 4px' }} />
						<div className="calendar-input" style={{ width: 140 }}>
							<DatePicker
								className="form-control form-control-sm"
								dateFormat="dd.MM.yyyy"
								selected={startDate}
								onChange={d => { if (d) setStartDate(d) }}
							/>
							<i className="uil uil-calendar-alt" />
						</div>
						<div className="calendar-input" style={{ width: 140 }}>
							<DatePicker
								className="form-control form-control-sm"
								dateFormat="dd.MM.yyyy"
								selected={endDate}
								onChange={d => { if (d) setEndDate(d) }}
							/>
							<i className="uil uil-calendar-alt" />
						</div>
						<button className="btn btn-sm btn-success" onClick={applyRefresh}>
							{loading
								? <span className="spinner-border spinner-border-sm" />
								: <><i className="uil uil-sync" /> Yangilash</>
							}
						</button>
					</div>
				</div>
			</div>

			{departments.length === 0 && !loading && (
				<div className="card">
					<div className="card-body text-center py-5 text-muted">
						<i className="uil-chart-bar" style={{ fontSize: 48, display: 'block', marginBottom: 12 }}></i>
						Tanlangan davr uchun ma'lumotlar yo'q
					</div>
				</div>
			)}

			{departments.length > 0 && (
				<div className="row g-3">
					{departments.map((dept, di) => {
						const color = deptColors[di % deptColors.length]
						return (
							<div key={dept.product_type_id} className="col-12">
								<div className="card" style={{ borderTop: `4px solid ${color}` }}>
									<div className="card-body">
										{/* Header row */}
										<div className="d-flex justify-content-between align-items-center mb-3">
											<h5 className="mb-0 fw-bold" style={{ color }}>
												<i className="uil-layer-group me-2"></i>
												{dept.product_type_name}
											</h5>
											<span className="badge" style={{ background: color, fontSize: 13 }}>
												{dept.log_count} ta yozuv
											</span>
										</div>

										{/* ═══ IKKI MANBA YONMA-YON ═══
										    Chapda — USTA QO'LDA yozgani, o'ngda — DASTUR cheklardan
										    hisoblagani. Ilgari ikkalasi bir qatorda, bir xil ko'rinishda
										    turardi va qaysi raqam qayerdan kelgani bilinmasdi.
										    Kraskachilarda (kg) chek bilan taqqoslash ma'nosiz — u yerda
										    faqat qo'lda yozilgan tomon ko'rsatiladi. */}
										{(() => {
											const paint = isPaint(dept.product_type_id)
											const u = dept.unit || 'metr'
											const qolda = paint ? Number(dept.total_paint_kg || 0) : Number(dept.total_metr || 0)
											const dastur = Number(dept.cheques_total || 0)
											const farq = qolda - dastur
											const foiz = dastur > 0 ? Math.round((farq / dastur) * 100) : null

											return (
												<div className="dd-src mb-3">
													<div className="dd-src-b" style={{ '--c': color }}>
														<div className="dd-src-h">
															<i className="uil-pen me-1" />QO'LDA YOZILGAN
															<span className="dd-src-w">usta yozadi</span>
														</div>
														<div className="dd-src-v">{mainAmount(dept)}</div>
														<div className="dd-src-s">
															{dept.log_count} ta yozuv · o'rtacha {dept.total_workers} ta ishchi/kun
														</div>
													</div>

													{!paint && (
														<div className="dd-src-b is-auto">
															<div className="dd-src-h">
																<i className="uil-receipt me-1" />DASTUR BO'YICHA
																<span className="dd-src-w">cheklardan hisoblanadi</span>
															</div>
															<div className="dd-src-v">{trim(dastur, 1)} {u}</div>
															<div className="dd-src-s">
																{dept.cheques_count || 0} ta chek «Tayyor» qilingan
															</div>
														</div>
													)}

													{!paint && (
														<div className={'dd-src-b is-diff ' + (Math.abs(farq) < 0.01 ? 'is-ok' : (farq > 0 ? 'is-plus' : 'is-minus'))}>
															<div className="dd-src-h">FARQ</div>
															<div className="dd-src-v">
																{farq > 0 ? '+' : ''}{trim(farq, 1)} {u}
															</div>
															<div className="dd-src-s">
																{foiz === null
																	? 'chek yo\'q'
																	: `${foiz > 0 ? '+' : ''}${foiz}% · qo'lda ${farq > 0 ? 'ko\'p' : (farq < 0 ? 'kam' : 'teng')}`}
															</div>
														</div>
													)}
												</div>
											)
										})()}

										<div className="row g-3">
											{/* Products made */}
											<div className="col-md-5">
												<div style={{ background: 'var(--dd-panel, #f8f9fa)', borderRadius: 8, padding: '12px 16px' }}>
													<div className="fw-bold mb-2" style={{ fontSize: 13, color: 'var(--dd-ink, #555)' }}>
														<i className="uil-box me-1"></i>Tayyorlangan mahsulotlar
													</div>
													{dept.items.length === 0 ? (
														<div className="text-muted" style={{ fontSize: 12 }}>Ma'lumot yo'q</div>
													) : (
														<table className="table table-sm mb-0" style={{ fontSize: 13 }}>
															<thead>
																<tr>
																	<th className="border-0 ps-0">Mahsulot</th>
																	<th className="border-0 text-end pe-0">Jami soni</th>
																</tr>
															</thead>
															<tbody>
																{dept.items.map((item, ii) => (
																	<tr key={ii}>
																		<td className="ps-0 border-0 py-1">{item.product_name}</td>
																		<td className="text-end pe-0 border-0 py-1 fw-bold text-nowrap">
																			{trim(item.total_quantity, 2)}
																			<small className="text-muted ms-1">{item.unit || ''}</small>
																		</td>
																	</tr>
																))}
															</tbody>
														</table>
													)}
												</div>
											</div>

											{/* QAYSI RULONDAN QANCHA KETDI.
											    Aksessuar/Tunukafonda asosiy savol shu: bir rulondan
											    necha metr list kesilgani. Faqat ma'lumot bo'lsa
											    ko'rsatiladi — kraskachilarda bu blok chiqmaydi. */}
											{dept.rolls && dept.rolls.length > 0 && (
												<div className="col-md-3">
													<div style={{ background: 'var(--dd-panel, #f8f9fa)', borderRadius: 8, padding: '12px 16px' }}>
														<div className="fw-bold mb-2" style={{ fontSize: 13, color: 'var(--dd-ink, #555)' }}>
															<i className="uil-layer-group me-1"></i>Rulondan kesilgan
														</div>
														{dept.rolls.map((r, ri) => (
															<div key={ri} className="d-flex justify-content-between align-items-center py-1"
																style={{ borderBottom: '1px solid var(--dd-line, #eee)', fontSize: 12.5 }}>
																<span className="text-truncate" style={{ maxWidth: 130 }}>{r.roll_name}</span>
																<b className="text-nowrap ms-2">{trim(r.total_metr, 1)} m</b>
															</div>
														))}
													</div>
												</div>
											)}

											{/* Workers — per brigadir submission */}
											<div className={dept.rolls && dept.rolls.length > 0 ? 'col-md-2' : 'col-md-4'}>
												<div style={{ background: 'var(--dd-panel, #f8f9fa)', borderRadius: 8, padding: '12px 16px' }}>
													<div className="fw-bold mb-2" style={{ fontSize: 13, color: 'var(--dd-ink, #555)' }}>
														<i className="uil-users-alt me-1"></i>Hisobot berganlar
													</div>
													{dept.workers.map((w, wi) => (
														<div key={wi} className="d-flex justify-content-between align-items-center py-1"
															style={{ borderBottom: '1px solid var(--dd-line, #eee)', fontSize: 13 }}>
															<div>
																<div>{w.worker_name || w.user_login}</div>
																<div className="text-muted" style={{ fontSize: 11 }}>
																	{w.total_workers} ta ishchi &middot; {w.log_count} ta yozuv
																</div>
															</div>
															<span className="badge text-nowrap" style={{ background: color }}>
																{isPaint(dept.product_type_id)
																	? trim(w.total_paint_kg, 1) + ' kg'
																	: trim(w.total_metr, 1) + ' ' + (dept.unit || 'metr')}
															</span>
														</div>
													))}
												</div>
											</div>

											{/* Daily breakdown */}
											<div className="col-md-3">
												<div style={{ background: 'var(--dd-panel, #f8f9fa)', borderRadius: 8, padding: '12px 16px' }}>
													<div className="fw-bold mb-2" style={{ fontSize: 13, color: 'var(--dd-ink, #555)' }}>
														<i className="uil-calendar-alt me-1"></i>Kunlik (so'nggi)
													</div>
													{dept.daily.slice(0, 7).map((d, di2) => (
														<div key={di2} className="d-flex justify-content-between align-items-center py-1"
															style={{ borderBottom: '1px solid var(--dd-line, #eee)', fontSize: 12 }}>
															<div>
																<div className="text-muted">
																	{formatDate(d.work_date, 'dd.MM.yyyy')}
																	{/* Jo'natilgan kun yashil belgili */}
																	{d.submitted_at && <i className="uil-check-circle text-success ms-1" />}
																</div>
																<div style={{ fontSize: 11, color: 'var(--dd-ink3, #aaa)' }}>{d.total_workers} ta ishchi</div>
															</div>
															{/* Ikki manba: QO'LDA yozilgani va DASTUR cheklardan hisoblagani.
															    Yorliq yozilgan — rahbar qaysi raqam qayerdan kelganini
															    ajratib turishi kerak (korxona egasining talabi). */}
															<div className="text-end">
																<span className="fw-bold text-nowrap">
																	{isPaint(dept.product_type_id)
																		? trim(d.total_paint_kg, 1) + ' kg'
																		: trim(d.total_metr, 1) + ' ' + (dept.unit || 'metr')}
																	<span style={{ fontSize: 10, fontWeight: 500, color: 'var(--dd-ink3, #aaa)' }}> qo'lda</span>
																</span>
																{!isPaint(dept.product_type_id) && (
																	<div className="text-nowrap" style={{ fontSize: 11, color: '#0891b2' }}>
																		{trim(d.cheques_metr, 1)} <span style={{ fontWeight: 500, opacity: .8 }}>dastur</span>
																	</div>
																)}
															</div>
														</div>
													))}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						)
					})}
				</div>
			)}
			</div>
	)
}
